/** @format */

import React, { createContext, useState, useEffect } from 'react'
import { Card, Tabs, Tab, _$ } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { useHistory, useLocation } from 'react-router'
import Contacts from './Contact'
import ContactGroup from './Group'
import Schedule from './Schedule'
import { request } from 'src/utils'
import { UserGroupProps } from 'src/containers/MonitorContacts/constants'
import API from 'src/api/ApiContacts'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}
export const CountContext = createContext<{
  groupList?: UserGroupProps[]
  getUserGroup?: () => void
}>({})

const MonitorContacts: React.FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const initialTab = query.get('tab') || 'man'
  const [tabValue, setTabValue] = useState<string>(initialTab)
  const [groupList, setGroupList] = useState<UserGroupProps[]>([])

  useEffect(() => {
    getUserGroup()
  }, [tabValue])

  // 获取联系组
  const getUserGroup = async () => {
    const result = await request(API.getUserGroup, {
      data: {
        Cap: 1,
        pageIndex: 1
      }
    })
    const { code, data } = result
    if (code === 'Success') {
      setGroupList(data?.usergrplist || [])
    }
  }

  return (
    <div className={className}>
      <CountContext.Provider
        value={{
          groupList,
          getUserGroup
        }}
      >
        <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('通知对象') }]} />
        <Card>
          <Tabs
            value={tabValue}
            onChangeValue={tab => {
              setTabValue(tab)
              history.push(`/monitor/alarmServer/alertTarget?tab=${tab}`)
            }}
          >
            <Tab value="man">{_$('联系人')}</Tab>
            <Tab value="group">{_$('联系组')}</Tab>
            <Tab value="schedule">{_$('值班管理')}</Tab>
          </Tabs>
          <div className="marginTop">
            <>
              {tabValue === 'man' && <Contacts />}
              {tabValue === 'group' && <ContactGroup />}
              {tabValue === 'schedule' && <Schedule />}
            </>
          </div>
        </Card>
      </CountContext.Provider>
    </div>
  )
}
export default styled(MonitorContacts)`
  .header {
    display: flex;
    & > * {
      margin-right: 8px;
    }
  }
  .k-table {
    margin-top: 16px;
  }
`
